export default __webpack_public_path__ + "static/media/11-23_B.7ac9e967.svg";